import React, { useState, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { Loader } from 'lucide-react';

const PublicRoute: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const isAuthenticated = useSelector(
    (state: RootState) => state.app.user.isAuthenticated,
  );
  const location = useLocation();

  const publicPaths = ['/contactus'];
  const isPublicPath = publicPaths.includes(location.pathname);

  useEffect(() => {
    const checkAuth = async () => {
      await new Promise((resolve) => setTimeout(resolve, 500));
      setLoading(false);
    };

    checkAuth();
  }, [isAuthenticated]);

  if (loading) {
    return (
      <div className="relative min-h-screen flex flex-col justify-center items-center">
        <Loader className="animate-spin" size={48} />
      </div>
    );
  }

  if (isAuthenticated && !isPublicPath) {
    return <Navigate to="/courses" replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
